export default __webpack_public_path__ + "static/media/signup.9937eea3.png";